<template>
    <div class="d-flex justify-space-between align-center pt-8">
        <TitleSection section="filters"/>
        <ButtonText @reset-method="resetFilters"/>
    </div>
</template>

<script>
    import ButtonText from "@/components/sidebar/cutaway/components/ButtonText";
    import TitleSection from "@/components/sidebar/cutaway/components/TitleSection";

    export default {
        name: "ResetFiltersButton",
        components: {
            ButtonText,
            TitleSection
        },
        methods: {
            resetFilters() {
                this.$emit('reset-method');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/sidebar/cutaway/components/ResetFiltersButton.vue